import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useChatConfig, useChatState } from '@/ui/ChatProvider';
/**
 * The visible half of the abandonment path: a warning while the chat can still
 * be rescued, then the closed notice. See `InactivityConfig`.
 *
 * NOT A MESSAGE, on purpose. It renders from state at the end of the
 * transcript rather than being appended to it, which keeps it out of the stored
 * transcript and out of the agent's history — the backend never saw it, and a
 * notice that looks like the agent speaking invites a reply to something the
 * agent has no idea it said.
 */
export function InactivityNotice() {
    const phase = useChatState((s) => s.inactivity);
    const byTeam = useChatState((s) => s.closedBy === 'team');
    const { copy, inactivity } = useChatConfig();
    if (phase === 'live')
        return null;
    const closed = phase === 'closed';
    const title = byTeam ? copy.endedTitle : closed ? copy.inactivityClosedTitle : copy.inactivityWarningTitle;
    const body = byTeam
        ? copy.endedBody
        : closed
            ? copy.inactivityClosedBody
            : copy.inactivityWarningBody.replace('{minutes}', formatMinutes(inactivity.closeAfterWarningMs));
    return (_jsxs("div", { className: "ac-notice", "data-phase": phase, role: "status", children: [_jsx("strong", { className: "ac-notice-title", children: title }), _jsx("span", { className: "ac-notice-body", children: body })] }));
}
/**
 * "1 minute" / "2 minutes", from the configured window, so the copy cannot
 * promise a deadline the timer does not keep. A window under a minute still
 * reads as one: the warning needs a number the visitor can act on.
 */
function formatMinutes(ms) {
    const minutes = Math.max(1, Math.round(ms / 60_000));
    return `${minutes} minute${minutes === 1 ? '' : 's'}`;
}
